"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireDefault(require("../../utils/system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.node.isRequired,

  /**
   * The positioning type.
   */
  position: (0, _propTypes.oneOf)(['absolute', 'fixed', 'relative', 'static', 'sticky']),

  /**
   * The positioning type.
   */
  variant: (0, _propTypes.oneOf)(['default', 'primary', 'secondary'])
};
var defaultProps = {
  color: 'default',
  position: 'fixed'
};
var AppBar = (0, _system["default"])('header')({
  label: 'AppBar'
}, (0, _css["default"])({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  width: '100%',
  zIndex: 'sticky'
}), (0, _styledSystem.variant)({
  variants: {
    "default": {
      bg: 'white',
      color: 'text'
    },
    primary: {
      bg: 'primary.main',
      color: 'white'
    },
    secondary: {
      bg: 'secondary.main',
      color: 'white'
    }
  }
}), function (_ref) {
  var position = _ref.position;
  return ['absolute', 'fixed', 'sticky'].includes(position) ? {
    top: 0,
    left: 'auto',
    right: 0
  } : null;
});
AppBar.displayName = 'AppBar';
AppBar.propTypes = propTypes;
AppBar.defaultProps = defaultProps;
var _default = AppBar;
exports["default"] = _default;

//# sourceMappingURL=AppBar.js.map